import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveProductUrl from '../../../utils/urls/resolve-product-url';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";
import Thumbnail from '../../thumbnail';

const SavingAccountProducts = ({ active }) => {
  const { category, products } = useStaticQuery(graphql`
    query SavingAccountProducts {
      category: mysqlTerms(cluster: {eq: "accounts_2"}) {
        term_normalized
        path
      }

      products: allMysqlAccount(
        filter: {type: {eq: 2}, form_visible: {eq: 1}}, 
        limit: 8
      ) {
        nodes {
          name
          specific_url
          prefix_url
          url
          bank {
            prefix_url
            specific_url
            url
          }
          mysqlImage {
            childImageSharp {
              gatsbyImageData(width: 70,  outputPixelDensities: [1, 2])
            }
          }
        }
      }
    }
  `);

  if (!products.nodes.length || !category) {
    return null;
  }

  return (<>
    <strong>Oferty kont oszczędnościowych</strong>

    <ul className={b.pt1}>
      {products.nodes.map((product, i) => (
        <li key={i} className={b.mt2}>
          <Link to={resolveProductUrl(product)} className="top-navigation-product">
            {active && <div className="top-navigation-product-image-fill">
              <Thumbnail image={product.mysqlImage} alt="" />
            </div>}
            
            <span>{product.name}</span>
          </Link>
        </li>
      ))}
    </ul>

    <Link className={[b.btn, "btn-light", "btn-cta", 'button-white', b.mt4].join(" ")} to={resolveUrl(category.path, category.term_normalized)}>
      {active && <Icon size={17} icon="Info" />}
      
      Informacje o kontach oszczędnościowych
    </Link>
  </>);
};

export default SavingAccountProducts;
